import { InputNote } from "@sellar-io/components";
import { type ReactNode } from "react";

export const invalidFieldClassName = "business-form-field-error scroll-mt-24";

export const requiredField = (label: string) => ({
  onSubmit: ({ value }: { value: unknown }) => {
    if (typeof value === "string") {
      return value.trim() ? undefined : `${label} is required`;
    }

    if (value === undefined || value === null || value === "") {
      return `${label} is required`;
    }

    return undefined;
  },
});

export const numberRequiredField = (label: string) => ({
  onSubmit: ({ value }: { value: unknown }) => {
    return typeof value === "number" && !Number.isNaN(value)
      ? undefined
      : `${label} is required`;
  },
});

export const getFieldError = (errors: unknown[]) => {
  return errors
    .map((error) => {
      if (
        error &&
        typeof error === "object" &&
        "message" in error &&
        typeof error.message === "string"
      ) {
        return error.message;
      }

      return String(error);
    })
    .filter(Boolean)
    .join(", ");
};

export const fieldNote = (note: ReactNode, errorMessage: string) => {
  if (errorMessage) {
    return <InputNote type="error">{errorMessage}</InputNote>;
  }

  return note;
};
